import { ApiClient, getTenantApplicationsProductDetailConfiguration } from '@ori/static-api-client';

import type { GetProductInfoDialogShowMrpStatementProps } from './types';

export const getProductInfoDialogShowMrpStatement = async ({
  staticApiUrl,
  tenant,
}: GetProductInfoDialogShowMrpStatementProps) => {
  const client = new ApiClient({ baseUrl: staticApiUrl });
  const {
    data: { isMrpStatementEnabled },
  } = await getTenantApplicationsProductDetailConfiguration(client, tenant);

  return isMrpStatementEnabled;
};
